var _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCellPhoneIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 10.637,
    height: 18,
    viewBox: "0 0 10.637 18",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Icon_material-phone-iphone",
    "data-name": "Icon material-phone-iphone",
    d: "M16.091,1.5H9.545A2.046,2.046,0,0,0,7.5,3.545V17.455A2.046,2.046,0,0,0,9.545,19.5h6.545a2.046,2.046,0,0,0,2.045-2.045V3.545A2.046,2.046,0,0,0,16.091,1.5ZM12.818,18.682a1.227,1.227,0,1,1,1.227-1.227A1.226,1.226,0,0,1,12.818,18.682ZM16.5,15.409H9.136V3.955H16.5Z",
    transform: "translate(-7.5 -1.5)",
    fill: "#004987"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCellPhoneIcon);
export default __webpack_public_path__ + "static/media/cell-phone-icon.c63d21f0656b56a0c756f00126aeb111.svg";
export { ForwardRef as ReactComponent };